export default [
  {
    header: 'Capa. & Entrenamiento',
    resource: 'Evaluacion Campo',
    action: 'read',
  },
  {
    //title: 'Liderazgo en campo',
    title: 'Campo',
    icon: 'LayoutIcon',
    children: [
      {
        title: 'Evaluaciones',
        route: 'evaluacioncampo',
        action: 'menu',
        resource: 'Evaluacion Campo'
      },
      {
        title: 'Plan Acción',
        route: 'planaccioncampo',
        action: 'menu',
        resource: 'Plan Accion Campo'
      },
    ],
  },
  {
    //title: 'Liderazgo en packing',
    title: 'Packing',
    icon: 'fa-solid fa-warehouse',
    children: [
      {
        title: 'Evaluaciones',
        route: 'evaluacionpacking',
        action: 'menu',
        resource: 'Evaluacion Packing'
      },
      {
        title: 'Plan Acción',
        route: 'planaccionpacking',
        action: 'menu',
        resource: 'Plan Accion Packing'
      },
    ],
  },
  {
    title: 'Capacitaciones',
    icon: 'fa-solid fa-users-line',
    children: [
      {
        title: 'Capacitaciones',
        route: 'capacitaciones',
        action: 'menu',
        resource: 'Capacitaciones'
      },
      {
        title: 'Temas',
        route: 'temascapacitaciones',
        action: 'menu',
        resource: 'Temas Capacitaciones'
      },
      {
        title: 'Todos',
        route: 'todoscapacitaciones',
        action: 'menu',
        resource: 'Todo Capacitaciones'
      },
      /*
      {
        title: 'Gráficos',
        route: 'graficoscapacitaciones',
        action: 'menu',
        resource: 'Graficos Capacitaciones'
      },
      {
        title: 'Asistentes',
        route: 'asistentescapacitaciones',
        action: 'menu',
        resource: 'Asistentes Capacitaciones'
      },
      */
      {
        title: 'Mant. Evaluadores',
        icon: 'fa-solid fa-database',
        children:[
            {
                title: '- Eval. Capacitación',
                action: 'menu',
                route: 'evaluadorcapa',
                resource: 'Asistentes Capacitaciones',
                // children:[
                //     {
                //         title: '- Capacitación',
                //         route: 'evaluadorcapa',
                //         action: 'menu',
                //         resource: 'Mantenedor Evaluador'
                //     },
                // ]
            }
        ],
      },

      // children: [
      //   {
      //       title: 'Categorías',
      //       action: 'menu',
      //       resource: 'Evaluaciones BBSS',
      //       children:[
      //           {
      //               title: '- AGV',
      //               route: 'categoriasagv',
      //               action: 'menu',
      //               resource: 'Evaluaciones BBSS'
      //           }
      //         ]
      //   },
      // ]
      // mm
    ],
  },
]
